<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'information.title'"></app-header-bar>
  </div>

  <app-information-folder></app-information-folder>
</div>
